import React, { Fragment, useState } from "react";

// UI Components
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";

// Custom components
import RegisterUser from "../../../components/forms/RegisterUser";

/**
 * The preview modal and associated button handlers
 * @constructor
 */
const AddUserModal = () => {
  // Local Variables
  const [showModal, setShowModal] = useState(false);

  const toggle = () => setShowModal(!showModal);

  const closeBtn = (
    <button className="close" onClick={toggle}>
      &times;
    </button>
  );

  return (
    <Fragment>
      {/* PREVIEW BUTTONS */}
      <Button color="primary" className="float-right" outline onClick={toggle}>
        <FontAwesomeIcon icon={faUserPlus} className="mr-2" />
        Add User
      </Button>

      {/* MODAL */}
      <Modal size="lg" isOpen={showModal} toggle={toggle}>
        <ModalHeader toggle={toggle} close={closeBtn} className="text-uppercase">
          Add New User
        </ModalHeader>

        <ModalBody>
          <div className="m-sm-4">
            <RegisterUser />
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default AddUserModal;
